var _path, _mask, _g, _mask2, _g2, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 48c34.242 0 62 3.582 62 8v53c0-4.418-27.758-8-62-8-34.242 0-62 3.582-62 8V56c0-4.418 27.758-8 62-8z",
    fill: "#4285F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 54,
    width: 124,
    height: 55
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 54c34.242 0 62 3.582 62 8v47c0-4.418-27.758-8-62-8-34.242 0-62 3.582-62 8V62c0-4.418 27.758-8 62-8z",
    fill: "#4285F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.34 54.505c1.322-1.028 3.025-1.028 4.346 0 1.997 1.556 2.76 1.732 3.406 1.732.646 0 1.41-.176 3.406-1.733 1.321-1.027 3.024-1.027 4.346 0 1.996 1.557 2.76 1.733 3.406 1.733.499 0 1.086-.118 2.29-.91l-9.513-16.472c-1.82-3.171-6.401-3.171-8.251 0L15.351 55.18c1.35.94 1.967 1.086 2.525 1.086.705-.03 1.468-.205 3.465-1.761z",
    fill: "#E8F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.016 62.57a9.352 9.352 0 00-8.104 4.669 6.315 6.315 0 00-4.316-1.703c-2.848 0-5.227 1.85-6.049 4.434h-3.465a5.67 5.67 0 00-5.666 5.666 5.67 5.67 0 005.666 5.667h21.934c5.167 0 9.366-4.198 9.366-9.366.03-5.168-4.17-9.367-9.366-9.367z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.556 97.872c-.998-.998-2.642-.998-3.67 0l-5.226 5.226-8.956-8.955c-.998-.998-2.642-.998-3.67 0l-5.402 5.432-21.757-37.671c-1.615-2.76-5.609-2.76-7.194 0L63.534 91.618 42.599 55.356c-1.204.793-1.762.91-2.29.91-.646 0-1.41-.176-3.406-1.732-1.322-1.028-3.025-1.028-4.346 0-1.997 1.556-2.76 1.732-3.406 1.732-.646 0-1.41-.176-3.406-1.732-1.321-1.028-3.024-1.028-4.346 0-1.996 1.556-2.76 1.732-3.406 1.732-.557 0-1.174-.117-2.525-1.086L-15.685 109H147.685l-11.129-11.128z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 74.57a5.707 5.707 0 014.945 2.849 3.853 3.853 0 012.633-1.04 3.861 3.861 0 013.691 2.706h2.114a3.46 3.46 0 013.457 3.458A3.46 3.46 0 01115.513 86H102.13a5.719 5.719 0 01-5.714-5.715c-.018-3.153 2.544-5.715 5.714-5.715z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.331 105.682l-3.699-6.4M70.023 102.511l-6.46-11.187M127.63 102.863l3.524 3.524",
    stroke: "#5F6368",
    strokeMiterlimit: 10
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 30,
    width: 43,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M7 30h43v34H7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.34 54.505c1.322-1.028 3.025-1.028 4.346 0 1.997 1.556 2.76 1.732 3.406 1.732.646 0 1.41-.176 3.406-1.733 1.321-1.027 3.024-1.027 4.346 0 1.996 1.557 2.76 1.733 3.406 1.733.499 0 1.086-.118 2.29-.91l-9.513-16.472c-1.82-3.171-6.401-3.171-8.251 0L15.351 55.18c1.35.94 1.967 1.086 2.525 1.086.705-.03 1.468-.205 3.465-1.761z",
    fill: "#D2E3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.556 97.872c-.998-.998-2.642-.998-3.67 0l-5.226 5.226-8.956-8.955c-.998-.998-2.642-.998-3.67 0l-5.402 5.432-21.757-37.671c-1.615-2.76-5.609-2.76-7.194 0L63.534 91.618 42.599 55.356c-1.204.793-1.762.91-2.29.91-.646 0-1.41-.176-3.406-1.732-1.322-1.028-3.025-1.028-4.346 0-1.997 1.556-2.76 1.732-3.406 1.732-.646 0-1.41-.176-3.406-1.732-1.321-1.028-3.024-1.028-4.346 0-1.996 1.556-2.76 1.732-3.406 1.732-.557 0-1.174-.117-2.525-1.086L-15.685 109H147.685l-11.129-11.128z",
    fill: "#34A853"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 61.064C9.25 59.684 4 57.922 4 56v53c0 1.921 5.25 3.685 14 5.064v-53zm96 53c8.75-1.379 14-3.143 14-5.064V56c0 1.922-5.25 3.685-14 5.064v53z",
    fill: "#DADCE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.017 31.05l-6.746.038 1.668-4.486 5.078 4.448z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.829 28.382c.111 1.482-1.075 2.706-2.558 2.706l-6.301-.037-.037-5.116 6.375.038c1.298 0 2.41 1.037 2.521 2.409z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.53 27.9c-.334.408-.297 1 .074 1.334.407.334 1 .297 1.334-.074.334-.37.297-1-.074-1.334-.371-.334-1-.297-1.335.074z",
    fill: "#5F6368"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.046 32.718v-8.525c-.037-2.854-2.26-5.597-5.375-5.56H76.623L87.261 27.9 71.73 24.119v8.859a4022.961 4022.961 0 0115.53-3.78l-10.638 9.266h15.05c3.187-.037 5.411-2.854 5.374-5.745z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullEvents);
export default __webpack_public_path__ + "static/media/nullEvents.c1914deccb202d302751bccdf4b8c316.svg";
export { ForwardRef as ReactComponent };